import { render } from "./FormSubEspecialidade.vue?vue&type=template&id=1b9a7454"
import script from "./FormSubEspecialidade.vue?vue&type=script&lang=js"
export * from "./FormSubEspecialidade.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__